import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';

var modal = {
	selectors: {
		element: '[modal-id]',
	},

	init: function () {
		var self = this;

		self.loadModals();
	},

	loadModals: function() {
		var self = this;

		jQuery(document.body).on('click', self.selectors.element, function ( event ) {
			event.preventDefault();

			var modalID = jQuery( this ).attr( 'modal-id' );

			if( jQuery( `.modal-${modalID}` ).length ) {
				self.openModal( modalID );
				return true;
			}

			jQuery.ajax({
				type: 'post',
				dataType: 'json',
				url: sikmoVars.ajax_url,
				data: {
					'action' : 'get_modal',
					'post_id' : modalID
				},
				success: function( response ) {
					if( response.success ) {
						jQuery( '.modals' ).append( `<div class="modal-${modalID}" style="display:none;">${response.data}</div>` );
						self.openModal( modalID );
					} else {
						jQuery.fancybox.open( `<p class="modal-error-message">${response.data}</p>` );
					}
				}
			});

		});
	},

	openModal: function( modalID ) {
		jQuery.fancybox.open({
			src  : `.modal-${modalID}`,
			type : 'inline',
		});
	}
};

export { modal };
